// extracted by mini-css-extract-plugin
export default {"title":"AddCoursesPopup_title__i6wmD","tableWrap":"AddCoursesPopup_tableWrap__OTX1n","action":"AddCoursesPopup_action__7oaxs"};